import { render } from "./AppWidgetWithCircle.vue?vue&type=template&id=64bac210"
import script from "./AppWidgetWithCircle.vue?vue&type=script&lang=js"
export * from "./AppWidgetWithCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__